import { useEffect, useState } from 'react';
import { Button, Row, Spin } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';

import { ModalMap } from '../../modalMap/ModalMap';
import { useCurrentGeolocation } from '../../../hooks/useCurrentGeolocation';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';

export const LocationDateComponent = ({ field, value, onChange, disabledField }) => {
  const { isLoading, currentGeolocation, getGeolocation } = useCurrentGeolocation();

  const [isOpenMapModal, setIsOpenMapModal] = useState(false);
  const { translate: t } = useDictionaryTranslation();
  const formatDate = (date) => date && moment(date).format('dddd DD MMMM YYYY (HH:mm:ss)');

  const openMapModal = () => {
    setIsOpenMapModal(true);
  };

  const closeMapModal = () => {
    setIsOpenMapModal(false);
  };

  useEffect(() => {
    if (value != null || currentGeolocation == null) return;
    onChange(currentGeolocation);
  }, [currentGeolocation]);

  return (
    <>
      <Spin spinning={isLoading}>
        {!value ? (
          <Row justify="end">
            <Button type="primary" disabled={value != null || disabledField} onClick={getGeolocation} block>
              {field.obligatory ? '*' : null}
              {field.label}
            </Button>
          </Row>
        ) : (
          <p>
            {formatDate(value?.time ?? value?.timestamp)} -{' '}
            <Button style={{ padding: 0 }} type="link" onClick={openMapModal}>
              {' '}
              {t('showLocation')}
            </Button>
          </p>
        )}
      </Spin>
      <ModalMap
        title={field.label}
        show={isOpenMapModal}
        handleClose={closeMapModal}
        userCoordinates={[
          {
            coordinates: [
              value?.coords?.longitude ?? value?.markerCoords?.longitude,
              value?.coords?.latitude ?? value?.markerCoords?.latitude,
            ],
          },
        ]}
      />
    </>
  );
};

LocationDateComponent.propTypes = {
  field: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.object,
  disabledField: PropTypes.bool,
};
